import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { SchoolService } from "../../../../../shared/services/school.service";
import { ApplicationAddRemoveRequest } from "../../shared/ApplicationAddRemoveRequest";
import { DataService_AppSetup } from "../../shared/data.service";

@Component({
	selector: "app-application-add-school",
	templateUrl: "./application-add-school.component.html",
	styleUrls: ["./application-add-school.component.css"],
})
export class ApplicationAddSchoolComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private schoolService: SchoolService,
		private dialogConfig: DynamicDialogConfig,
		private tableService: DataService_AppSetup,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.ApplicationID = this.dialogConfig.data.ApplicationID;

		//Get Data from DB
		this.loadSchoolist();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	processing: any = false;
	loading: any = false;
	errorMessage: any = "";

	ApplicationID: any = "";
	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadSchoolist() {
		this.loading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.UpdateSelected();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	UpdateSelected() {
		this.SelectedSchools = this.dialogConfig.data.SelectedSchools;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.errorMessage = "";

		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to remove";
			return;
		}

		this.processing = true;

		//
		// Create Request
		//

		//School IDs
		var lstSchool: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			if (next != undefined && next.SchoolID != undefined) {
				lstSchool = [...lstSchool, next.SchoolID];
			}
		}

		let parms: ApplicationAddRemoveRequest = {
			ApplicationID: this.ApplicationID,
			lstSchoolIDs: lstSchool,
		};

		//
		// Call SP
		//
		var result = this.tableService.ApplicationAddSchools(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Application added to schools successfully. NOTE: you will have to refresh the page to see new menu items.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
						reject: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add schools",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////
	IsLoading() {
		return this.loading == true || this.processing == true;
	}
	///////////////////////////////////////////////////////
}
